const NotasPago = [
    {
        id: 0,
        recaudo: "Registrar el pago en el sistema del Instituto a través de la página www.iudlm.com."
    },
    {
        id: 1,
        recaudo: "Registrar la fecha de la transferencia (día/mes/año)."
    },
    {
        id: 2,
        recaudo: "Registrar el número de referencia de la transferencia. Es muy importante que verifique que éste número es correcto ya que el mismo permitirá realizar la validación del pago."
    },
    {
        id: 3,
        recaudo: "Indicar Nombre, Apellido y Cédula de Identidad del titular de la Cuenta Bancaria que realizó la transferencia."
    },
    {
        id: 4,
        recaudo: "Si es Pago Móvil indicar el número telefónico de la persona que realizó el pago."
    },
    {
        id: 5,
        recaudo: "Registrar el monto exacto de la transferencia."
    }
]

export default NotasPago;


// WEBPACK FOOTER //
// ./src/shared/NotasPago.jsx